import { writable } from 'svelte/store';
import { PMT } from './functions';
import _ from 'lodash';

/*let storedInfo = JSON.parse(localStorage.getItem('info'));
if (storedInfo === null) {
    storedInfo = { name: '', income: 0, hours_month: 168, result_income_hour: 0, level_indebtedness: 0, amount_money_paid: 0, spending_hours_in_advance: 0, payment_option_credit: null };
}*/
let storedInfo = { name: '', income: 0, hours_month: 168, result_income_hour: 0, level_indebtedness: 0, amount_money_paid: 0, spending_hours_in_advance: 0, payment_option_credit: null };

export const info = writable(storedInfo);
info.subscribe(value => {
    value.result_income_hour = Number((Number(value.income) / value.hours_month).toFixed(2));
    localStorage.setItem('info', JSON.stringify(value));
});


    let storedCredits = [
        {
            name: '',
            loan_amount: '',
            duration: '',
            interest_rate: '',
            interest_rate_annually: 0,
            monthly_payment: 0,
            amount_paid: 0,
            interest_paid: 0,
        }
    ];


export const credits = writable(storedCredits);
credits.subscribe(credits => {
    credits = _.map(credits, credit => {
        if (credit.loan_amount > 0 && credit.duration > 0) {
            if (credit.interest_rate === 0) {
                credit.monthly_payment = credit.loan_amount / credit.duration;
            } else {
                credit.interest_rate_annually = credit.interest_rate / 1200;
                // credit.monthly_payment = (credit.loan_amount * credit.interest_rate_annually) / (1 - Math.pow((1 + credit.interest_rate), -credit.duration));
                credit.monthly_payment = PMT(credit.interest_rate_annually, credit.duration, credit.loan_amount);
            }
            credit.amount_paid = credit.monthly_payment * credit.duration;
            credit.interest_paid = credit.amount_paid - credit.loan_amount;
        }

        return credit;
    });
    localStorage.setItem('credits', JSON.stringify(credits));
});
